// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_vuc","cls2":"CoScientistPricingPage-cls2_2td CoScientistPricingPage-cls1_vuc"};